import React from 'react';
import { motion } from 'framer-motion';
export function AuthorSection() {
  return <section className="py-20 bg-primary relative overflow-hidden" data-id="element-15" data-mp="sbfwinhsvjvc">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[1px] bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-16" data-mp="sda8vdf0a3nt" />
      <div className="absolute -bottom-[200px] -left-[200px] w-[500px] h-[500px] rounded-full bg-[radial-gradient(ellipse,rgba(212,175,55,0.04)_0%,transparent_70%)] pointer-events-none" data-id="element-17" data-mp="1293urnem79i9" />
      
      <div className="max-w-[1100px] mx-auto px-5 relative z-10" data-id="element-18" data-mp="9l7ygjsyjjm0">
        <div className="grid grid-cols-1 md:grid-cols-[380px_1fr] gap-10 md:gap-16 items-center text-center md:text-left" data-id="element-19" data-mp="9ivanq0iqf11">
          
          {/* Visual de la Abu */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col items-center gap-6" data-id="element-20" data-mp="jhb3bxf71wcn">
            <div className="relative" data-id="element-21" data-mp="3mxi2bqmnz5f3">
              <div className="w-[200px] h-[200px] md:w-[260px] md:h-[260px] rounded-full bg-gradient-to-br from-gold via-violet to-gold p-[3px] animate-ring-glow" data-id="element-22" data-mp="2von7nxw5k4mf">
                <div className="w-full h-full rounded-full bg-card overflow-hidden relative flex items-center justify-center" data-id="element-23" data-mp="2zn2qrqp44suk">
                  <img src="https://cdn.magicpatterns.com/uploads/bKVPYdzCMdRB2pKzFG35oE/Woman_expressing_tranquility_and…_2K_202608241746.jpg" alt="La Abu - Mentora de Vida" className="w-full h-full object-cover" data-id="element-24" data-mp="39frxk89pxijk" />
                </div>
              </div>
              
              <div className="absolute bottom-2 -right-2 md:-right-4 bg-card border border-gold/15 rounded-xl px-4 py-2.5 flex items-center gap-2 text-[13px] font-semibold text-gold shadow-[0_8px_24px_rgba(0,0,0,0.4)] whitespace-nowrap" data-id="element-25" data-mp="2locw0hprn59d">
                <span className="text-lg" data-id="element-26" data-mp="5y9vkhgmn5r2">✨</span>
                Mentora de Vida
              </div>
            </div>

            <div className="grid grid-cols-3 gap-3 w-full max-w-[320px]" data-id="element-27" data-mp="3cez47jttw7yk">
              <div className="bg-card border border-gold/15 rounded-xl p-3 text-center" data-id="element-28" data-mp="37gxnh5jvkkq9">
                <div className="font-display text-[22px] font-black text-gold leading-none mb-1" data-id="element-29" data-mp="3mdy4ae0j2v9y">+10k</div>
                <div className="text-[11px] text-gray-400 leading-[1.3]" data-id="element-30" data-mp="3hf4rknt2f8au">Vidas<br data-id="element-31" data-mp="3hfmug3a8gkrq" />Impactadas</div>
              </div>
              <div className="bg-card border border-gold/15 rounded-xl p-3 text-center" data-id="element-32" data-mp="2tohi3y3i4am6">
                <div className="font-display text-[22px] font-black text-gold leading-none mb-1" data-id="element-33" data-mp="2oqpq742uwohz">15+</div>
                <div className="text-[11px] text-gray-400 leading-[1.3]" data-id="element-34" data-mp="33fc4d2gqza7m">Años de<br data-id="element-35" data-mp="33gx0uxmmh384" />Experiencia</div>
              </div>
              <div className="bg-card border border-gold/15 rounded-xl p-3 text-center" data-id="element-36" data-mp="2ynlq4leow2ax">
                <div className="font-display text-[22px] font-black text-gold leading-none mb-1" data-id="element-37" data-mp="2axre26272hrq">100%</div>
                <div className="text-[11px] text-gray-400 leading-[1.3]" data-id="element-38" data-mp="25ywwt8jvl19q">Entrega y<br data-id="element-39" data-mp="lhxh1enwygym" />Amor</div>
              </div>
            </div>
          </motion.div>

          {/* Contenido de la Abu */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-40" data-mp="q9fh80i44dij">
            <div className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.12em] uppercase text-gold mb-4" data-id="element-41" data-mp="gib476bzz2qc">
              Conoce a tu guía
            </div>
            <h2 className="font-display text-3xl md:text-[48px] font-black leading-[1.15] text-white mb-6" data-id="element-42" data-mp="1462jmisu3vvu">
              Hola, soy La Abu.
            </h2>
            
            <div className="text-base text-gray-400 leading-[1.85] space-y-4" data-id="element-43" data-mp="v6p7tjh8mv7y">
              <p data-id="element-44" data-mp="z80y7r7xrkh7">
                Durante años vi a mujeres increíbles conformarse con vidas a medias. Mujeres con un potencial inmenso que sentían que "eso" no era para ellas. Yo misma estuve ahí.
              </p>
              <p data-id="element-45" data-mp="3k02qq57d6uh5">
                Descubrí que la manifestación no es magia de cuentos de hadas; es <strong className="text-white font-semibold" data-id="element-46" data-mp="423b4we63vno">física cuántica, neurociencia y alineación emocional</strong>. Cuando entendí cómo sintonizar mi frecuencia, mi vida entera cambió.
              </p>
              <p data-id="element-47" data-mp="3qhea78v7bo5n">
                Hoy, mi misión es simple: <em className="text-gold not-italic font-medium" data-id="element-48" data-mp="3qea240em889p">acortar tu curva de aprendizaje</em>. He empaquetado todo lo que sé, todo lo que funciona y todo lo que necesitas en este sistema. No quiero que pases años intentando descifrar el código. Quiero que empieces a vivir la vida que mereces, hoy.
              </p>
            </div>

            <div className="flex items-center justify-center md:justify-start gap-4 p-5 bg-gold/5 border border-gold/15 rounded-xl mt-7" data-id="element-49" data-mp="d0oqkioceuk8">
              <div className="font-script text-3xl text-gold leading-none" data-id="element-50" data-mp="927inwx3lg1r">
                La Abu
              </div>
              <div className="text-[13px] text-gray-500 mt-1" data-id="element-51" data-mp="2tqdfadsl4gq1">
                Tu mentora en este viaje
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </section>;
}